import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { BROKER_CONNECT_ACCENT } from '../../constants/brokerConnectColors';

/**
 * Centered icon-badge + heading used atop each step of the broker connect
 * flow (inline chart panel and ConnectBrokerModal), so every step reads as
 * "this is what you do next" through sizing/hierarchy alone.
 */
export default function BrokerStepHeading({ icon, iconColor, heading, subtitle, size = 48 }) {
  const { colors } = useTheme();
  const accent = iconColor || BROKER_CONNECT_ACCENT;

  return (
    <div style={{ textAlign: 'center', marginBottom: 36 }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 18px',
          background: `${accent}17`,
          border: `1px solid ${accent}66`,
        }}
      >
        {icon}
      </div>
      <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: colors.text, margin: subtitle ? '0 0 6px' : 0 }}>
        {heading}
      </h2>
      {subtitle && (
        <p style={{ color: colors.textLight, fontSize: 13, margin: 0 }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
